import {Box, IconButton, Typography} from '@mui/material';
import {t} from 'i18next';
import AddIcon from '@mui/icons-material/Add';
import ArrButton from '../../../../common/arr-button/ArrButton';
import AutoGrowTextField from '../auto-grow-text-field';
import {ReactComponent as DeleteIcon} from '../../../../../assets/images/close-base-icon.svg';
import {buildAddItemAriaLabel} from './utils';
import './StringListField.scss';

export interface StringListFieldProps {
  label: string;
  items?: string[] | null;
  placeholder: string;
  readOnly?: boolean;
  dataTestId: string;
  onChange: (index: number, value: string) => void;
  onAdd: () => void;
  onDelete: (index: number) => void;
}

const StringListField: React.FC<StringListFieldProps> = ({
  label,
  items,
  placeholder,
  readOnly = false,
  dataTestId,
  onChange,
  onAdd,
  onDelete,
}) => {
  const list = items ?? [];
  const displayItems = list.length > 0 ? list : [''];
  const fieldAriaLabel = buildAddItemAriaLabel(label, placeholder);

  return (
    <Box className="string-list-field" data-testid={dataTestId}>
      <Typography className="string-list-field__label typo-text label2_size">
        {label}
      </Typography>
      <Box className="string-list-field__items">
        {displayItems.map((item, index) => (
          <Box
            key={`${dataTestId}-item-${index}`}
            className="string-list-field__item"
          >
            {readOnly ? (
              <Typography className="string-list-field__readonly typo-text body3_size">
                {item || '-'}
              </Typography>
            ) : (
              <AutoGrowTextField
                className="string-list-field__field"
                placeholder={placeholder}
                ariaLabel={fieldAriaLabel}
                value={item}
                onChange={(value) => onChange(index, value)}
                dataTestId={`${dataTestId}-input-${index}`}
              />
            )}
            {!readOnly && displayItems.length > 1 && (
              <IconButton
                className="string-list-field__delete-btn"
                onClick={() => onDelete(index)}
                size="small"
                aria-label={`${t('common.delete')} ${label}`}
                data-testid={`${dataTestId}-delete-${index}`}
              >
                <DeleteIcon aria-hidden="true" />
              </IconButton>
            )}
          </Box>
        ))}
      </Box>
      {!readOnly && (
        <ArrButton
          variant="text"
          size="small"
          startIcon={<AddIcon />}
          className="string-list-field__add-btn"
          dataTestId={`${dataTestId}-add`}
          onClick={onAdd}
          aria-label={`${t('common.add')} ${label}`}
        >
          {t('common.add')}
        </ArrButton>
      )}
    </Box>
  );
};

export default StringListField;
